export const ButtonBlock = {
  transclude: true,

  bindings: {
    ngDisabled: '<',
    onClick: '&',
  },

  template: `
    <button class="btn p-3 theme-btn"
      type="button"
      ng-disabled="$ctrl.ngDisabled"
      ng-click="$ctrl.onClick()"
      ng-transclude>
    </button>`,
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonBlock.js